import { Routes } from '@angular/router';
import { registryCommerceDefaultRedirectGuard } from './ui/commerce-registry/guards/registry-commerce-default-redirect.guard';
import { registryCommerceInicioGuard } from './ui/commerce-registry/guards/registry-commerce-inicio.guard';
import { registryCommerceLandingExistsGuard } from './ui/commerce-registry/guards/registry-commerce-landing-exists.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'comercio/demo/inicio' },
  {
    path: '404',
    loadComponent: () =>
      import('./ui/commerce-registry/pages/commerce-not-found/commerce-not-found').then((m) => m.CommerceNotFound),
  },
  {
    path: 'comercio/:commerceId/leaderboard/:leaderboardId',
    loadComponent: () =>
      import('./ui/leaderboard/pages/leaderboard-public/leaderboard-public').then((m) => m.LeaderboardPublic),
  },
  {
    path: 'comercio/:comercioSlug',
    canActivate: [registryCommerceLandingExistsGuard],
    loadComponent: () =>
      import('./ui/commerce-registry/pages/registry-shell/registry-shell').then((m) => m.RegistryShell),
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [registryCommerceDefaultRedirectGuard],
        loadComponent: () =>
          import('./ui/commerce-registry/pages/registry-commerce-default-redirect/registry-commerce-default-redirect').then(
            (m) => m.RegistryCommerceDefaultRedirect,
          ),
      },
      {
        path: 'inicio',
        canActivate: [registryCommerceInicioGuard],
        loadComponent: () =>
          import('./ui/commerce-registry/pages/registry-landing/registry-landing').then((m) => m.RegistryLanding),
      },
      {
        path: 'formulario-registro',
        loadComponent: () =>
          import('./ui/commerce-registry/pages/registry-layout/registry-layout').then((m) => m.RegistryLayout),
      },
    ],
  },
  { path: '**', redirectTo: '/404' },
];
